<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z" stroke="white" stroke-opacity="0.7" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.22168 6.89062V10.7795H13.1106" stroke="white" stroke-opacity="0.7" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
